import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { QcStatus } from '@/store/api/qcApi';
import type { RootState } from '@/store/store';

export interface QcUIState {
  selectedResultId: string | null;
  statusFilter: QcStatus | '';
  departmentFilter: string;
  projectFilter: string;
  searchQuery: string;
  detailPanelOpen: boolean;
}

const initialState: QcUIState = {
  selectedResultId: null,
  statusFilter: '',
  departmentFilter: '',
  projectFilter: '',
  searchQuery: '',
  detailPanelOpen: false,
};

const qcSlice = createSlice({
  name: 'qcUI',
  initialState,
  reducers: {
    setStatusFilter(state, action: PayloadAction<QcStatus | ''>) {
      state.statusFilter = action.payload;
    },
    setDepartmentFilter(state, action: PayloadAction<string>) {
      state.departmentFilter = action.payload;
    },
    setProjectFilter(state, action: PayloadAction<string>) {
      state.projectFilter = action.payload;
    },
    setSearchQuery(state, action: PayloadAction<string>) {
      state.searchQuery = action.payload;
    },
    selectResult(state, action: PayloadAction<string>) {
      if (state.selectedResultId === action.payload && state.detailPanelOpen) {
        state.detailPanelOpen = false;
        state.selectedResultId = null;
      } else {
        state.selectedResultId = action.payload;
        state.detailPanelOpen = true;
      }
    },
    closeDetail(state) {
      state.detailPanelOpen = false;
      state.selectedResultId = null;
    },
  },
});

export const {
  setStatusFilter,
  setDepartmentFilter,
  setProjectFilter,
  setSearchQuery,
  selectResult,
  closeDetail,
} = qcSlice.actions;

export const selectQcUI = (state: RootState) => state.qcUI;

export default qcSlice.reducer;
